// extracted by mini-css-extract-plugin
export default {"pageWrap":"Pb-z","fullWidth":"Qb-z","heading":"Rb-z","fullBleed":"Sb-z","hidden":"Tb-z"};